import React from 'react';


const Career = () => {
    return(<>
  
  <section id="header" className="d-flex align-items-center">
        <div className="container-fluid">
            <div className="row">
                <div className="col-10 mx-auto">
                <div className="row">  
                    <div className="col-md-6 pt-lg-0 order-2 order-lg-1  d-flex flex-column justify-content-center">
                        <h3 className="design">  <strong className="bold_div"> <br /> EVERYDAY WE'RE LOOKING </strong> FOR THOSE WHO WILL TAKE THE WORLD FURTHER.</h3>
                        
                        
                    </div>
     
               
                    </div>
   
                </div>
            </div>
        </div>
        
    </section>

    <section id="header" className="d-flex align-items-center">
        <div className="container-fluid">
            <div className="row">
                <div className="col-10 mx-auto">
                <div className="row">  
                    <div className="col-md-6 pt-lg-0 order-2 order-lg-1  d-flex flex-column justify-content-center">
          <p className="career-div">
          We are constantly looking for driven and passionate people to join our teams - both at Elevation and at our portfolio companies. We believe that hiring the right team is crucial to transforming ideas into impactful products and ultimately, to building great companies.
          </p>
                        
                        
                    </div>
     
               
                    </div>
   
                </div>
            </div>
        </div>
        
    </section>
   

     
    </>
    );
}
export default Career;